import React, { useState } from 'react';
import './faq.css';

import { FaChevronDown, FaChevronUp, FaEye, FaGlasses, FaUserMd, FaCalendarAlt, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';

function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What services does your Community Eye Care Center provide?",
      answer: "We offer comprehensive eye examinations, vision screenings, prescription glasses, treatment for common eye conditions, and referrals for specialized care. Our services are focused on providing affordable eye care to underserved communities."
    },
    {
      question: "Who can access your services?",
      answer: "Our services are available to all community members, with priority given to low-income individuals, seniors, children, and those without access to regular eye care. We serve everyone regardless of their ability to pay."
    },
    {
      question: "Do I need an appointment for an eye exam?",
      answer: "While walk-ins are welcome for basic screenings, we recommend appointments for comprehensive eye exams to minimize waiting times. You can book an appointment by calling our centers or through our website."
    },
    {
      question: "How much do your services cost?",
      answer: "We operate on a sliding scale based on income. Basic vision screenings are often free, while comprehensive exams and glasses are offered at significantly reduced costs compared to private practices. No one is turned away due to inability to pay."
    },
    {
      question: "Do you provide free glasses?",
      answer: "We provide free basic prescription glasses to qualifying individuals through our donor-supported programs. For those who can contribute, we offer low-cost options with a range of frames to choose from."
    },
    {
      question: "What eye conditions do you treat?",
      answer: "We diagnose and manage common eye conditions including refractive errors, presbyopia, dry eyes, conjunctivitis, and early-stage glaucoma. For complex conditions, we provide referrals to partner ophthalmologists."
    },

    {
      question: "Do you offer mobile eye clinics?",
      answer: "Yes, we operate mobile eye clinics that visit underserved neighborhoods, rural areas, schools, and senior centers. Check our website or call us for the mobile clinic schedule."
    },
    // {
    //   question: "Can I volunteer at your center?",
    //   answer: "We welcome volunteers including optometrists, opticians, general helpers, and administrative support. Medical volunteers need appropriate credentials. Please visit our 'Get Involved' page for more information."
    // },
    {
      question: "How can my organization partner with you?",
      answer: "We collaborate with corporations, NGOs, and community organizations through various partnership models including sponsorship of eye camps, equipment donations, and CSR initiatives. Contact our partnerships team for more details."
    }
  ];

  return (
    <div className="faq-container">
      <div className="faq-header">
        <h2><FaEye className="header-icon" /> Frequently Asked Questions</h2>
        <p>Find answers to common questions about our Community Eye Care services</p>
      </div>

      <div className="faq-grid">
        {faqs.map((faq, index) => (
          <div 
            className={`faq-item ${activeIndex === index ? 'active' : ''}`} 
            key={index}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <h3>{faq.question}</h3>
              {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="contact-promo">
        <h3>Still have questions?</h3>
        <div className="contact-methods">
          <div className="contact-method">
            <FaPhone className="contact-icon" />
            <p>Call us: +94 11 7 700904</p>
          </div>
          <div className="contact-method">
            <FaMapMarkerAlt className="contact-icon" />
            <p>Visit us: Maradana Road, Colombo 08</p>
          </div>
          <div className="contact-method">
            <FaCalendarAlt className="contact-icon" />
            <p>Open Mon-Sat: 9:00 AM - 6:00 PM</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQSection;